import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-administrationmenu',
  templateUrl: './administrationmenu.component.html',
  styleUrls: ['./administrationmenu.component.scss']
})
export class AdministrationmenuComponent implements OnInit {
  userRoles: string[] = [];
  canDoBotRegistration: boolean = false;
  canSeeAgentHistory :boolean =false;
  constructor() { }

  ngOnInit() {
    this.userRoles = sessionStorage.getItem('userRoles') ? sessionStorage.getItem('userRoles').split(',') : [];
    let botRegistrationView = this.userRoles.find(ob => ob.toLowerCase() === 'superadmin' || ob.toLowerCase() === 'super admin');
    let agentHistoryView=this.userRoles.find(ob => ob.toLowerCase() === 'superadmin' || ob.toLowerCase() === 'super admin' || ob.toLowerCase() === 'chatbotadmin' || ob.toLowerCase() === 'chatbot admin'|| ob.toLowerCase() === 'businessmanager' || ob.toLowerCase() === 'business manager');
  
    if (botRegistrationView) {
      this.canDoBotRegistration = true;      
    }
    if(agentHistoryView) {      
      this.canSeeAgentHistory=true;
    }
  }

}
